import React from "react";
import { getWindowWidth, isSearchMobile } from "../../../../../../../services";
import AllSearchControls from "./AllSearchControls";
import MobileAllSearchControls from "./MobileAllSearchControls";
import MobileSearchGroup from "./MobileSearchGroup";
import SearchGroup from "./SearchGroup";
import { useDropdownBugfix } from "./hooks/useDropdownBugfix";

const SearchGroups = props => {
  const {
    closeAllSearch,
    form,
    groupConfigs,
    numberOfControls,
    onSubmit,
    onReset,
    showAllControls,
    setShowAllControls
  } = props;

    const { maxWidth, divRef} = useDropdownBugfix(groupConfigs.length)


  if (groupConfigs.length === 0) {
    return null;
  }

  const isMobile = isSearchMobile(getWindowWidth());

  // When the detailed-search panel opens, hide the always-visible quick
  // search bar (SearchGroup) and let AllSearchControls render every group,
  // turning the primary fields into the first "Osnovni podaci" accordion.
  const renderRestGroup = () => (
    <MobileAllSearchControls
      form={form}
      onSubmit={onSubmit}
      onReset={onReset}
      groupConfigs={groupConfigs}
      isMobile={isMobile}
      numberOfControls={numberOfControls}
      showAllControls={showAllControls}
      closeAllSearch={closeAllSearch}
      maxWidth={maxWidth}
    />
  );

  return (
    <div
      ref={divRef}
      style={{ width: "100%" }}
    >
      {!showAllControls && (
        isMobile ? (
          <MobileSearchGroup
            form={form}
            groupConfig={groupConfigs[0]}
            onSubmit={onSubmit}
            onReset={onReset}
            isMobile={isMobile}
            showAllControls={showAllControls}
            maxWidth={maxWidth}
          />
        ) : (
          <SearchGroup
            form={form}
            groupConfig={groupConfigs[0]}
            onSubmit={onSubmit}
            onReset={onReset}
            isMobile={isMobile}
            showAllControls={showAllControls}
            setShowAllControls={setShowAllControls}
          />
        )
      )}

      {isMobile ? (
        renderRestGroup()
      ) : (
        <AllSearchControls
          form={form}
          onSubmit={onSubmit}
          onReset={onReset}
          groupConfigs={groupConfigs}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          showAllControls={showAllControls}
          setShowAllControls={setShowAllControls}
          closeAllSearch={closeAllSearch}
        />
      )}
    </div>
  );
};

export default SearchGroups;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/index.tsx